const stages = [
  'Target',
  'Proposal',
  'Simulation',
  'Validation',
  'Authorization',
  'Execution',
]

export function EngineeringPanel() {
  return (
    <section className="module-card">

      <header>
        <strong>
          Ingeniería
        </strong>

        <span>
          Sesión supervisada
        </span>
      </header>

      <div className="progress-title">

        <strong>
          Preparando
        </strong>

        <span>
          1 / 6
        </span>

      </div>

      <div className="progress">
        <span />
      </div>

      <div className="timer">
        00:00
      </div>

      <div className="stages">

        {stages.map(
          (
            stage,
            index,
          ) => (
            <div
              key={stage}
            >
              <span>
                {
                  index === 0
                    ? '✓'
                    : '○'
                }
              </span>

              {stage}
            </div>
          ),
        )}

      </div>

    </section>
  )
}
